import React from 'react'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Title from 'components/_new/typography/deprecated/Title/Title'
import { WidthContainer } from 'components/_new/layout/widthContainer'
import MainSection from 'components/_new/layout/MainSection/MainSection'

import BrandsSlider from './BrandsSlider/BrandsSlider'

import messages from './messages'
import s from './BrandsSection.scss'


const BrandsSection = () => (
  <MainSection>
    <WidthContainer>
      <Box className={s.titleContainer} alignCenter center>
        <Title message={messages.title} />
      </Box>
      <Text message={messages.subTitle} align="center" />
      <Box mt="24">
        <BrandsSlider />
      </Box>
      <Box mt="24">
        <Text message={messages.text} size="12-24" uppercase muted align="center" />
      </Box>
    </WidthContainer>
  </MainSection>
)


export default BrandsSection
